import { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserContext } from 'context/User/UserContext';
import { raiseErrorBanner } from '../../components/MessageDispatch/messageDispatch';
import { getNotifications } from './components/Notifications/_api';
import { NotificationTable } from './components/Notifications/NotificationTable/NotificationTable';
import { RequestWidget } from './components/Widgets/Requests/RequestWidget';
import { RequestTypes } from '../../constants/enums';
import AnnouncementsCollection from '../CMS/CMSDisplayComponents/Announcement/AnnouncementsCollection';
import FavoritesWidget from './components/Widgets/Favorites/FavoritesWidget';
import { getSession, setSession } from '../../store/utility';
import { getPath } from 'routes/_utils';

import classes from './Home.module.scss';

const Home = () => {
	const dispatch = useDispatch();
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	const [sNotifications, setNotifications] = useState(null);

	const [redirectURL, setRedirectURL] = useState(null);

	// set redirectURL equal to the value from the session that may have been set by other ASPX pages in the event that a redirect url has been applied and was expected to be redirected to via startupResolver.aspx
	useEffect(() => {
		const initialize = async () => {
			let redirectURL = await getSession('StartupResolver_RedirectUrl');
			setRedirectURL(getPath(redirectURL));
			if (redirectURL) {
				await setSession('StartupResolver_RedirectUrl', null);
			}
		};

		initialize();
	}, []);

	/**
	 * Asynchronous hook on identifiable user profile. Retrieves and stores user notifications in local state.
	 * @returns void
	 */
	useEffect(() => {
		/**
		 * Asynchronously retrieves, stores notifications.
		 * @param {number} id user unique identifier.
		 * @returns void
		 */
		const render = async id => {
			try {
				const notifications = await getNotifications(id, dispatch);
				setNotifications(notifications);
			} catch (error) {
				raiseErrorBanner(error.cause ? error.cause : error, dispatch);
			}
		};

		if (user?.ID) {
			render(user.ID);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	return (
		<>
			{redirectURL == null || redirectURL === '' ? (
				<div className={classes['container']}>
					<div>
						<FavoritesWidget />
						<NotificationTable
							identity={user}
							notifications={sNotifications}
						/>
						<div className={classes['flex-row']}>
							<RequestWidget
								title='Your Requests'
								subtitle='Recent requests you have submitted for others.'
								type={RequestTypes.SINGLE}
							/>
							<RequestWidget
								title='Your Requests For Self'
								subtitle='Recent requests you have submitted for yourself.'
								type={RequestTypes.SELF}
							/>
						</div>
					</div>
					<div>
						<AnnouncementsCollection />
					</div>
				</div>
			) : (
				<Redirect to={redirectURL} />
			)}
		</>
	);
};

export { Home };
